import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../../../../ui/theme/colors';

export const useSearchResultCustomerStyles = makeStyles({
  name: {
    fontSize: '16px',
    fontWeight: 600
  },
  details: {
    color: Colors.midLightGray,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});
